'use strict';

module.exports = (app) => app.directive('paginationTop', /* @ngInject */ function() {
	return {
		restrict: 'E',
		scope: {
			totalLabel: '=',
			foundElementsLabel: '=',
			numberShowLabel: '=',
			totalEntries: '=',
			pageSize: '=',
			offset: '=',
			loadData: '=',
		},
		templateUrl: `./${BUILD_PATH}/pagination.top.directive.html`,
		controller: /* @ngInject */ function ($scope) {

			/**
			 * executes parent functions after change of the select
			 */
			$scope.executeData = function(){
				if(typeof $scope.loadData !== 'undefined'){
					$scope.loadData($scope.pageSize);
					$scope.offset = 0;
				}
			}
		}
	};
});
